import FrequencyComponent from "./FrequencyComponent";
import { FrequencyComponentType } from "./types";

const FrequencyComponentContainer = (props: FrequencyComponentType) => {
  return <FrequencyComponent {...props} />;
};

export default FrequencyComponentContainer;
